module.exports = __webpack_public_path__ + "fonts/Ubuntu-Title.73371cee.ttf";